const actions = {
  ADD_VIEW_START_LOG: 'vod/ADD_VIEW_START_LOG',
  ADD_VIEW_UPDATE_LOG: 'vod/ADD_VIEW_UPDATE_LOG',
}

export default actions
